var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { injectRoute } from '../inject-route';
var cachedRoutes = new Map();
export var getInjectedProjectRoute = function (_a) {
    var projectMainRoute = _a.projectMainRoute, router = _a.router, menuItemData = _a.menuItemData;
    var staticURL = menuItemData.staticURL || '';
    if (cachedRoutes.has(staticURL)) {
        return cachedRoutes.get(staticURL);
    }
    injectRoute({
        router: router,
        injectedRoute: projectMainRoute,
    });
    cachedRoutes.set(staticURL, __assign(__assign({}, menuItemData), { path: projectMainRoute.path, routeName: projectMainRoute.name }));
    return __assign(__assign({}, menuItemData), { path: projectMainRoute.path, 
        // Если нужно провалиться вглубь роутов в проекте - например внутрь табов
        routeName: projectMainRoute.redirectInsideRouteName || projectMainRoute.name });
};
